/**
 * The toast surface, which was copy-pasted verbatim in 31 places across these
 * screens. Same string, one home — the toast itself is unchanged.
 */
export const TOAST_SURFACE =
  'bg-white px-6 py-4 text-dark text-center rounded-none rounded-bl-lg rounded-br-lg shadow-[0_6px_16px_rgba(0,0,0,0.25)] max-w-xs text-sm';
